import '../../app-configuration/app-configuration.js';
import { KatapultPageElement, html } from '../../mixins/katapult-page-element';

import '@polymer/neon-animation/neon-animation';
import '@polymer/paper-dialog/paper-dialog';
import '@polymer/paper-tooltip/paper-tooltip';

import '@polymer/iron-icon/iron-icon';
import '@polymer/iron-icons/iron-icons';
import '@polymer/iron-icons/editor-icons';
import '@polymer/iron-icons/maps-icons';
import '@polymer/iron-icons/image-icons';
import '@polymer/iron-icons/av-icons';
import '@polymer/iron-icons/communication-icons';

import '../katapult-toolbar/katapult-toolbar';
import '../katapult-map-icons/katapult-map-icons';
import '../paper-header/paper-header';
import '../paper-table/paper-table';
import '../highlight-text/highlight-text';
import '../hash-bind/hash-bind';
import '../material-icon/material-icon';

import '../katapult-auth/katapult-auth';

import './katapult-model-space-creation-wizard';
import './katapult-model-space-pla-import-wizard';
import './katapult-model-editor-workspace';
import './shared-model-space-details.js';
import { DefaultStyle } from './katapult-model-editor-style';
import { AnimationManager } from './animationManager';

import '../katapult-animated-text/katapult-animated-text.js';
import '../katapult-elements/katapult-button.js';
import { addFlagListener, removeFlagListener } from '../../modules/FeatureFlags.js';
import { listenToTransferLocking } from '../../modules/TransferLocking.js';
import './tags/model-tags-editor.js';
import './tags/category-tags-icon.js';

class KatapultModelEditorPage extends KatapultPageElement {
  static get template() {
    return html`
      ${DefaultStyle}
      <style>
        :host {
          font-family: Roboto;
          overflow: hidden;
          color: var(--paper-grey-800);
        }
        [slot='auth-content'] {
          display: flex;
          flex-direction: column;
          height: 100%;
          width: 100%;
        }
        #mainHoriz {
          display: flex;
          position: relative;
          overflow: hidden;
          flex-grow: 1;
          background: var(--paper-grey-50);
        }
        #sideNavPanel {
          display: flex;
          flex-direction: column;
          background: white;
          @apply --shadow-elevation-2dp;
          z-index: 1;
        }
        #sideNavPanelScroll {
          overflow-y: auto;
          overflow-x: hidden;
        }
        #sideNavPanel::-webkit-scrollbar {
          width: 0;
          background-color: red;
        }
        #sideNavPanel paper-header-content {
          --paper-header: {
            color: var(--paper-grey-800);
            padding: 0 4px;
          };
          --paper-header-hover: {
            cursor: pointer;
          };
          --paper-header-closed: {
            border-bottom: 1px solid var(--paper-grey-300);
          };
        }
        #sideNavPanel paper-header-content > paper-header {
          padding-left: 32px;
          transition: all 0.3s;
        }
        #sideNavPanel[collapsed] paper-header-content > paper-header {
          padding-left: 4px;
        }
        #importToolWrapper {
          position: absolute;
          height: 100%;
          width: 100%;
          padding: 48px;
          box-sizing: border-box;
          z-index: 2;
          background: rgba(255, 255, 255, 0.6);
        }

        #workspaceContainer {
          position: relative;
          flex-grow: 1;
        }

        #workspaceContainer > * {
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: 100%;
        }
        paper-header {
          padding: 0 4px;
        }

        #readOnlyBanner {
          background: #ffcc00;
          color: black;
          display: flex;
          justify-content: center;
          align-items: center;
          text-align: center;
          padding: 16px;
        }
      </style>

      <katapult-map-icons model-key="[[modelSpace]]"></katapult-map-icons>
      <hash-bind prop1="{{modelSpace}}" prop2="{{category}}" prop3="{{selectedItem}}"></hash-bind>

      <katapult-dialog-legacy
        id="transferInProgressDialog"
        opened="[[showTransferInProgressDialog(modelSpace, modelsLockedForTransfer, companyModels)]]"
        modal
      >
        <div slot="title">
          <div>No Model Editor Access</div>
        </div>
        <div slot="body" style="margin-bottom:10px;">
          You do not have permission to modify these models since they are currently being transferred to a private server.
        </div>
        <div slot="buttons">
          <katapult-button color="var(--secondary-color)" on-click="returnToModels">Return To Models</katapult-button>
        </div>
      </katapult-dialog-legacy>

      <katapult-dialog-legacy
        id="onlyAdmins"
        opened="[[showNoAccessDialog(userGroup, adminsOnly, isAdmin, userPermissions, userPermissionsLoading)]]"
        modal
      >
        <div slot="title">
          <div>No Model Editor Access</div>
        </div>
        <div slot="body" style="margin-bottom:10px;">
          You do not have permission to modify these models. Speak to a company admin to request access.
        </div>
        <div slot="buttons">
          <template is="dom-if" if="{{showModelReturnButton}}">
            <katapult-button color="var(--secondary-color)" on-click="returnToModels">Return To Models</katapult-button>
          </template>
        </div>
      </katapult-dialog-legacy>

      <paper-dialog id="deleteModelSpaceDialog">
        <div title red>
          <iron-icon icon="delete-forever"></iron-icon>
          <span>Delete This [[modelSpaceDetails.type]]?</span>
        </div>
        <div body style="text-align: center;">
          <template is="dom-if" if="[[modelsLockedForDeletion]]">
            <p>Once jobs have been created with these models, you cannot delete them through this interface.</p>
            <p>
              Contact Katapult at <a href="mailto:support@katapultengineering.com">support@katapultengineering.com</a> to delete this model.
            </p>
          </template>
          <template is="dom-if" if="[[!modelsLockedForDeletion]]">
            <p>
              You are are about to delete the
              <span style="font-weight: bold;">[[modelSpaceDetails.label]]</span> [[modelSpaceDetails.typeLowercase]].
            </p>
            <p style="font-weight: bold;">This action cannot be reversed!</p>
            <p>Additionally, any jobs which use this model will not function properly until they are assigned a new model.</p>
            <p>Are you sure you want to continue?</p>
          </template>
        </div>
        <div buttons>
          <katapult-button dialog-dismiss>Cancel</katapult-button>
          <template is="dom-if" if="[[!modelsLockedForDeletion]]">
            <katapult-button
              style="margin-left: 16px"
              color="var(--paper-red-500)"
              loading="[[deletingModelSpace]]"
              on-click="confirmDeleteModelSpace"
              >Delete [[modelSpaceDetails.label]]</katapult-button
            >
          </template>
        </div>
      </paper-dialog>

      <katapult-firebase-worker
        id="userPermissions"
        path="users/[[rootCompany]]/[[user.uid]]/roles/photoheight/permissions"
        data="{{userPermissions}}"
        loading="{{userPermissionsLoading}}"
        disabled="[[!signedIn]]"
      ></katapult-firebase-worker>
      <katapult-firebase-worker
        id="adminsOnly"
        path="photoheight/company_space/[[modelSpace]]/models/config/model_editor/admins_only"
        data="{{adminsOnly}}"
        disabled="[[!signedIn]]"
      ></katapult-firebase-worker>
      <katapult-firebase-worker
        id="userModules"
        path="photoheight/company_space/[[userGroup]]/subscription/modules"
        data="{{userModules}}"
        disabled="[[!signedIn]]"
      ></katapult-firebase-worker>
      <katapult-firebase-worker
        id="modelsLockedForDeletion"
        path="photoheight/company_space/[[modelSpace]]/options/models_locked_for_deletion"
        data="{{modelsLockedForDeletion}}"
        disabled="[[!signedIn]]"
      ></katapult-firebase-worker>
      <katapult-firebase-worker
        id="companyModules"
        path="photoheight/company_space/[[userGroup]]/subscription/modules"
        data="{{companyModules}}"
        disabled="[[!signedIn]]"
      ></katapult-firebase-worker>
      <katapult-firebase-worker
        path="photoheight/company_space/[[modelSpace]]/models/export_models/dds/utility_name"
        data="{{ddsExportUtilityName}}"
        disabled="[[!signedIn]]"
      ></katapult-firebase-worker>
      <katapult-firebase-worker
        path="photoheight/company_space/[[modelSpace]]/portal_config/sync_to_models"
        data="{{syncToModels}}"
        disabled="[[!enabledFeatures.shared_workflow_configs]]"
      ></katapult-firebase-worker>
      <katapult-auth
        user="{{user}}"
        user-group="{{userGroup}}"
        root-company="{{rootCompany}}"
        signed-in="{{signedIn}}"
        company="{{userCompanyName}}"
        admin="{{isAdmin}}"
        no-signup="[[!config.firebaseData.offerLicenses]]"
        on-sign-in="onSignIn"
      >
        <div slot="title-content">
          <p style="margin: 0;">[[config.firebaseData.name]] Maps</p>
        </div>
        <div id="loginDescription" slot="description-content">
          <p>[[config.firebaseData.name]] Maps allows you to design and share survey jobs with Maps and Photos from any computer.</p>
          <p>Gather data for a permanent record of real-world conditions in minutes!</p>
        </div>
        <div slot="auth-content">
          <model-tags-editor id="modelTagsEditor" model-path="[[modelSpaceDetails.path]]"></model-tags-editor>
          <template is="dom-if" if="{{showReadOnlyBanner}}">
            <div id="readOnlyBanner">
              <div style="flex-grow: 1;"></div>
              <div>Read Only Access</div>
              <div style="flex-grow: 1;"></div>
              <material-icon style="flex-grow: 0;" icon="clear" pointer on-click="hideReadOnlyBanner"></material-icon>
            </div>
          </template>
          <katapult-toolbar id="toolbar" flexible-regions user-group="{{userGroup}}" job-creator="[[modelSpace]]">
            <div title slot="left">[[config.firebaseData.name]] Model Editor</div>
            <paper-table id="modelSpaceChooser" style="margin-left: 48px;" white outline rounded slot="left">
              <paper-row>
                <paper-cell icon>
                  <template is="dom-if" if="[[!modelSpaceDetails.icon]]">
                    <iron-icon icon="group-work"></iron-icon>
                  </template>
                  <template is="dom-if" if="[[modelSpaceDetails.icon]]">
                    <iron-icon icon="[[modelSpaceDetails.icon]]"></iron-icon>
                  </template>
                </paper-cell>
                <paper-cell style="padding-left: 0;">
                  <katapult-drop-down
                    class="modelList"
                    items="[[modelSpaceChooserOptions]]"
                    value="[[modelSpaceDetails]]"
                    on-value-changed="modelSpaceInputChanged"
                    label="Select a Model"
                    label-path="label"
                    value-path="."
                    no-label-float
                  >
                    <paper-item on-click="createNewModelSpace">CREATE NEW MODEL</paper-item>
                  </katapult-drop-down>
                </paper-cell>
              </paper-row>
            </paper-table>
            <katapult-button id="modelTagsEditorButton" slot="right" style="margin-right: 8px;" icon="label" on-click="openModelTagsEditor"
              >Tags</katapult-button
            >
            <katapult-button id="showImportPlaButton" icon="3d_rotation" slot="right" on-click="beginImportPla" style="margin-right: 8px;"
              >Import PLA</katapult-button
            >
            <katapult-button id="importFromCatalogButton" icon="import_contacts" slot="right" on-click="importFromCatalog"
              >Import From Catalog</katapult-button
            >
          </katapult-toolbar>
          <div id="mainHoriz">
            <div id="sideNavPanel" collapsed$="[[navPanelCollapsed]]">
              <div id="sideNavPanelScroll" style="flex-grow: 1;">
                <paper-header selected$="[[equal(category, 'attributes')]]" tall name="attributes" on-click="clickNavItem">
                  <paper-cell icon>
                    <iron-icon icon="list"></iron-icon>
                  </paper-cell>
                  <paper-cell>
                    <span>Attributes</span>
                  </paper-cell>
                </paper-header>
                <paper-header selected$="[[equal(category, 'attribute_sets')]]" tall name="attribute_sets" on-click="clickNavItem">
                  <paper-cell icon>
                    <iron-icon icon="line-style"></iron-icon>
                  </paper-cell>
                  <paper-cell>
                    <span>Attribute Sets</span>
                  </paper-cell>
                </paper-header>
                <paper-header selected$="[[equal(category, 'tools')]]" tall name="tools" on-click="clickNavItem">
                  <paper-cell icon>
                    <material-icon icon="construction"></material-icon>
                  </paper-cell>
                  <paper-cell>
                    <span>Tools</span>
                  </paper-cell>
                </paper-header>
                <paper-header selected$="[[equal(category, 'toolsets')]]" tall name="toolsets" on-click="clickNavItem">
                  <paper-cell icon>
                    <material-icon icon="home_repair_service"></material-icon>
                  </paper-cell>
                  <paper-cell>
                    <span>Toolsets</span>
                  </paper-cell>
                </paper-header>
                <paper-header selected$="[[equal(category, 'photo_elements')]]" tall name="photo_elements" on-click="clickNavItem">
                  <paper-cell icon>
                    <material-icon icon="category"></material-icon>
                  </paper-cell>
                  <paper-cell>
                    <span>Photo Elements</span>
                  </paper-cell>
                </paper-header>
                <paper-header selected$="[[equal(category, 'photo_routines')]]" tall name="photo_routines" on-click="clickNavItem">
                  <paper-cell icon>
                    <iron-icon icon="image:add-to-photos"></iron-icon>
                  </paper-cell>
                  <paper-cell>
                    <span>Photo Routines</span>
                  </paper-cell>
                </paper-header>
                <paper-header selected$="[[equal(category, 'photo_toolsets')]]" tall name="photo_toolsets" on-click="clickNavItem">
                  <paper-cell icon>
                    <iron-icon icon="image:photo-library"></iron-icon>
                  </paper-cell>
                  <paper-cell>
                    <span>Photo Toolsets</span>
                  </paper-cell>
                </paper-header>
                <template is="dom-if" if="{{companyModules.make_ready}}">
                  <paper-header-content tall>
                    <paper-cell icon slot="header">
                      <iron-icon icon="editor:format-line-spacing"></iron-icon>
                    </paper-cell>
                    <paper-cell slot="header">
                      <span>Make Ready</span>
                    </paper-cell>
                    <paper-header
                      selected$="[[equal(category, 'clearance_rules')]]"
                      slot="content"
                      name="clearance_rules"
                      on-click="clickNavItem"
                    >
                      <paper-cell icon>
                        <iron-icon icon="swap-vert"></iron-icon>
                      </paper-cell>
                      <paper-cell>
                        <span>Clearance Rules</span>
                        <category-tags-icon
                          style="margin-left: auto;"
                          category="clearance_rules"
                          model-path="[[modelSpaceDetails.path]]"
                          tags-path="[[modelSpaceDetails.path]]/models/category_tags/clearance_rules"
                        ></category-tags-icon>
                      </paper-cell>
                    </paper-header>
                    <paper-header
                      selected$="[[equal(category, 'proposed_cable_logic')]]"
                      slot="content"
                      name="proposed_cable_logic"
                      on-click="clickNavItem"
                    >
                      <paper-cell icon>
                        <iron-icon icon="star-border"></iron-icon>
                      </paper-cell>
                      <paper-cell>
                        <span>Proposed Cable Logic</span>
                        <category-tags-icon
                          style="margin-left: auto;"
                          category="proposed_cable_logic"
                          model-path="[[modelSpaceDetails.path]]"
                          tags-path="[[modelSpaceDetails.path]]/models/category_tags/proposed_cable_logic"
                        ></category-tags-icon>
                      </paper-cell>
                    </paper-header>
                    <template is="dom-if" if="[[companyModules.make_ready_engineering]]">
                      <paper-header
                        selected$="[[equal(category, 'virtual_rideout')]]"
                        slot="content"
                        name="virtual_rideout"
                        on-click="clickNavItem"
                      >
                        <paper-cell icon>
                          <material-icon icon="directions_car"></material-icon>
                        </paper-cell>
                        <paper-cell>
                          <span>Virtual Rideout</span>
                        </paper-cell>
                      </paper-header>
                    </template>
                  </paper-header-content>

                  <template is="dom-if" if="[[enabledFeatures.construction_specs]]" restamp>
                    <paper-header-content tall>
                      <paper-cell icon slot="header">
                        <material-icon icon="construction"></material-icon>
                      </paper-cell>
                      <paper-cell slot="header">
                        <span>Construction</span>
                      </paper-cell>

                      <paper-header
                        selected$="[[equal(category, 'construction_specs')]]"
                        slot="content"
                        name="construction_specs"
                        on-click="clickNavItem"
                      >
                        <paper-cell icon>
                          <iron-icon icon="image:straighten"></iron-icon>
                        </paper-cell>
                        <paper-cell>
                          <span>Construction Specs</span>
                        </paper-cell>
                      </paper-header>
                      <template is="dom-if" if="[[enabledFeatures.compatible_unit_editor]]" restamp>
                        <paper-header
                          selected$="[[equal(category, 'compatible_units')]]"
                          slot="content"
                          name="compatible_units"
                          on-click="clickNavItem"
                        >
                          <paper-cell icon>
                            <iron-icon icon="av:art-track"></iron-icon>
                          </paper-cell>
                          <paper-cell>
                            <span>Compatible Units</span>
                          </paper-cell>
                        </paper-header>
                        <paper-header
                          selected$="[[equal(category, 'compatible_unit_automations')]]"
                          slot="content"
                          name="compatible_unit_automations"
                          on-click="clickNavItem"
                        >
                          <paper-cell icon>
                            <material-icon icon="photo_filter"></material-icon>
                          </paper-cell>
                          <paper-cell>
                            <span>Compatible Unit Automations</span>
                          </paper-cell>
                        </paper-header>
                      </template>
                    </paper-header-content>
                  </template>
                </template>
                <template is="dom-if" if="[[or(companyModules.pole_loading_exports, companyModules.integrated_pole_loading)]]">
                  <paper-header-content tall>
                    <paper-cell icon slot="header">
                      <iron-icon icon="3d-rotation"></iron-icon>
                    </paper-cell>
                    <paper-cell slot="header">
                      <span>Pole Loading</span>
                    </paper-cell>
                    <template is="dom-if" if="[[companyModules.integrated_pole_loading]]">
                      <paper-header
                        selected$="[[equal(category, 'default_specs')]]"
                        slot="content"
                        name="default_specs"
                        on-click="clickNavItem"
                      >
                        <paper-cell icon>
                          <material-icon icon="settings"></material-icon>
                        </paper-cell>
                        <paper-cell>
                          <span>Default Settings</span>
                          <category-tags-icon
                            style="margin-left: auto;"
                            category="default_specs"
                            model-path="[[modelSpaceDetails.path]]"
                            tags-path="[[modelSpaceDetails.path]]/models/category_tags/default_specs"
                          ></category-tags-icon>
                        </paper-cell>
                      </paper-header>
                      <paper-header selected$="[[equal(category, 'pole_specs')]]" slot="content" name="pole_specs" on-click="clickNavItem">
                        <paper-cell icon>
                          <material-icon icon="track_changes"></material-icon>
                        </paper-cell>
                        <paper-cell>
                          <span>Pole Specs</span>
                          <category-tags-icon
                            style="margin-left: auto;"
                            category="pole_specs"
                            model-path="[[modelSpaceDetails.path]]"
                            tags-path="[[modelSpaceDetails.path]]/models/category_tags/pole_specs"
                          ></category-tags-icon>
                        </paper-cell>
                      </paper-header>
                      <paper-header selected$="[[equal(category, 'wire_specs')]]" slot="content" name="wire_specs" on-click="clickNavItem">
                        <paper-cell icon>
                          <material-icon icon="line_weight"></material-icon>
                        </paper-cell>
                        <paper-cell>
                          <span>Wire Specs</span>
                          <category-tags-icon
                            style="margin-left: auto;"
                            category="wire_specs"
                            model-path="[[modelSpaceDetails.path]]"
                            tags-path="[[modelSpaceDetails.path]]/models/category_tags/wire_specs"
                          ></category-tags-icon>
                        </paper-cell>
                      </paper-header>
                      <paper-header
                        selected$="[[equal(category, 'anchor_specs')]]"
                        slot="content"
                        name="anchor_specs"
                        on-click="clickNavItem"
                      >
                        <paper-cell icon>
                          <material-icon icon="arrow_drop_down"></material-icon>
                        </paper-cell>
                        <paper-cell>
                          <span>Anchor Specs</span>
                          <category-tags-icon
                            style="margin-left: auto;"
                            category="anchor_specs"
                            model-path="[[modelSpaceDetails.path]]"
                            tags-path="[[modelSpaceDetails.path]]/models/category_tags/anchor_specs"
                          ></category-tags-icon>
                        </paper-cell>
                      </paper-header>
                      <paper-header
                        selected$="[[equal(category, 'insulator_specs')]]"
                        slot="content"
                        name="insulator_specs"
                        on-click="clickNavItem"
                      >
                        <paper-cell icon>
                          <material-icon icon="adjust"></material-icon>
                        </paper-cell>
                        <paper-cell>
                          <span>Insulator Specs</span>
                          <category-tags-icon
                            style="margin-left: auto;"
                            category="insulator_specs"
                            model-path="[[modelSpaceDetails.path]]"
                            tags-path="[[modelSpaceDetails.path]]/models/category_tags/insulator_specs"
                          ></category-tags-icon>
                        </paper-cell>
                      </paper-header>
                      <paper-header selected$="[[equal(category, 'arm_specs')]]" slot="content" name="arm_specs" on-click="clickNavItem">
                        <paper-cell icon>
                          <material-icon icon="drag_handle"></material-icon>
                        </paper-cell>
                        <paper-cell>
                          <span>Arm Specs</span>
                          <category-tags-icon
                            style="margin-left: auto;"
                            category="arm_specs"
                            model-path="[[modelSpaceDetails.path]]"
                            tags-path="[[modelSpaceDetails.path]]/models/category_tags/arm_specs"
                          ></category-tags-icon>
                        </paper-cell>
                      </paper-header>
                      <paper-header
                        selected$="[[equal(category, 'equipment_specs')]]"
                        slot="content"
                        name="equipment_specs"
                        on-click="clickNavItem"
                      >
                        <paper-cell icon>
                          <material-icon icon="settings_overscan"></material-icon>
                        </paper-cell>
                        <paper-cell>
                          <span>Equipment Specs</span>
                          <category-tags-icon
                            style="margin-left: auto;"
                            category="equipment_specs"
                            model-path="[[modelSpaceDetails.path]]"
                            tags-path="[[modelSpaceDetails.path]]/models/category_tags/equipment_specs"
                          ></category-tags-icon>
                        </paper-cell>
                      </paper-header>
                      <paper-header
                        selected$="[[equal(category, 'sidewalk_brace_specs')]]"
                        slot="content"
                        name="sidewalk_brace_specs"
                        on-click="clickNavItem"
                      >
                        <paper-cell icon>
                          <material-icon icon="horizontal_rule"></material-icon>
                        </paper-cell>
                        <paper-cell>
                          <span>Sidewalk Brace Specs</span>
                          <category-tags-icon
                            style="margin-left: auto;"
                            category="sidewalk_brace_specs"
                            model-path="[[modelSpaceDetails.path]]"
                            tags-path="[[modelSpaceDetails.path]]/models/category_tags/sidewalk_brace_specs"
                          ></category-tags-icon>
                        </paper-cell>
                      </paper-header>
                      <paper-header
                        selected$="[[equal(category, 'pushbrace_specs')]]"
                        slot="content"
                        name="pushbrace_specs"
                        on-click="clickNavItem"
                      >
                        <paper-cell icon>
                          <material-icon icon="horizontal_rule" style="transform: rotate(-60deg);"></material-icon>
                        </paper-cell>
                        <paper-cell>
                          <span>Pushbrace Specs</span>
                          <category-tags-icon
                            style="margin-left: auto;"
                            category="pushbrace_specs"
                            model-path="[[modelSpaceDetails.path]]"
                            tags-path="[[modelSpaceDetails.path]]/models/category_tags/pushbrace_specs"
                          ></category-tags-icon>
                        </paper-cell>
                      </paper-header>
                      <paper-header selected$="[[equal(category, 'load_cases')]]" slot="content" name="load_cases" on-click="clickNavItem">
                        <paper-cell icon>
                          <material-icon icon="air"></material-icon>
                        </paper-cell>
                        <paper-cell>
                          <span>Load Cases</span>
                          <category-tags-icon
                            style="margin-left: auto;"
                            category="load_cases"
                            model-path="[[modelSpaceDetails.path]]"
                            tags-path="[[modelSpaceDetails.path]]/models/category_tags/load_cases"
                          ></category-tags-icon>
                        </paper-cell>
                      </paper-header>
                    </template>
                  </paper-header-content>
                </template>
                <paper-header-content tall>
                  <paper-cell icon slot="header">
                    <iron-icon icon="editor:multiline-chart"></iron-icon>
                  </paper-cell>
                  <paper-cell slot="header">
                    <span>Exports</span>
                  </paper-cell>
                  <paper-header selected$="[[equal(category, 'photo_forms')]]" slot="content" name="photo_forms" on-click="clickNavItem">
                    <paper-cell icon>
                      <iron-icon icon="image:photo-album"></iron-icon>
                    </paper-cell>
                    <paper-cell>
                      <span>Photo Forms</span>
                    </paper-cell>
                  </paper-header>
                  <paper-header
                    selected$="[[equal(category, 'map_print_templates')]]"
                    slot="content"
                    name="map_print_templates"
                    on-click="clickNavItem"
                  >
                    <paper-cell icon>
                      <iron-icon icon="print"></iron-icon>
                    </paper-cell>
                    <paper-cell>
                      <span>Map Print Templates</span>
                    </paper-cell>
                  </paper-header>
                  <paper-header
                    selected$="[[equal(category, 'saved_view_templates')]]"
                    slot="content"
                    name="saved_view_templates"
                    on-click="clickNavItem"
                  >
                    <paper-cell icon>
                      <iron-icon icon="katapult-misc:preview"></iron-icon>
                    </paper-cell>
                    <paper-cell>
                      <span>Saved View Templates</span>
                    </paper-cell>
                  </paper-header>
                  <template is="dom-if" if="[[enabledFeatures.configurable_exports]]">
                    <paper-header
                      selected$="[[equal(category, 'configurable_exports')]]"
                      slot="content"
                      name="configurable_exports"
                      on-click="clickNavItem"
                    >
                      <paper-cell icon>
                        <iron-icon icon="icons:apps"></iron-icon>
                      </paper-cell>
                      <paper-cell>
                        <span>Configurable Exports</span>
                      </paper-cell>
                    </paper-header>
                  </template>
                  <template is="dom-if" if="[[companyModules.make_ready_engineering]]">
                    <paper-header
                      selected$="[[equal(category, 'make_ready_notification')]]"
                      slot="content"
                      name="make_ready_notification"
                      on-click="clickNavItem"
                    >
                      <paper-cell icon>
                        <material-icon icon="notifications"></material-icon>
                      </paper-cell>
                      <paper-cell>
                        <span>Make Ready Notification</span>
                      </paper-cell>
                    </paper-header>
                  </template>
                  <template is="dom-if" if="[[enabledFeatures.dds_export]]">
                    <paper-header selected$="[[equal(category, 'dds_bundles')]]" slot="content" name="dds_bundles" on-click="clickNavItem">
                      <paper-cell icon>
                        <material-icon icon="line_weight"></material-icon>
                      </paper-cell>
                      <paper-cell>
                        <span>DDS Bundles</span>
                      </paper-cell>
                    </paper-header>
                  </template>
                  <template is="dom-if" if="[[enabledFeatures.web_automations]]">
                    <paper-header
                      selected$="[[equal(category, 'web_automations')]]"
                      slot="content"
                      name="web_automations"
                      on-click="clickNavItem"
                    >
                      <paper-cell icon>
                        <iron-icon icon="icons:picture-in-picture"></iron-icon>
                      </paper-cell>
                      <paper-cell>
                        <span>Web Automations</span>
                      </paper-cell>
                    </paper-header>
                  </template>
                </paper-header-content>
                <paper-header-content tall>
                  <paper-cell icon slot="header">
                    <iron-icon icon="image:style"></iron-icon>
                  </paper-cell>
                  <paper-cell slot="header">
                    <span>Map Styles</span>
                  </paper-cell>
                  <paper-header selected$="[[equal(category, 'custom_icons')]]" slot="content" name="custom_icons" on-click="clickNavItem">
                    <paper-cell icon>
                      <iron-icon icon="change-history"></iron-icon>
                    </paper-cell>
                    <paper-cell>
                      <span>Custom Icons</span>
                    </paper-cell>
                  </paper-header>
                  <paper-header
                    selected$="[[equal(category, 'custom_line_styles')]]"
                    slot="content"
                    name="custom_line_styles"
                    on-click="clickNavItem"
                  >
                    <paper-cell icon>
                      <iron-icon icon="line-style"></iron-icon>
                    </paper-cell>
                    <paper-cell>
                      <span>Custom Line Styles</span>
                    </paper-cell>
                  </paper-header>
                </paper-header-content>

                <paper-header-content tall>
                  <paper-cell icon slot="header">
                    <iron-icon icon="hardware:smartphone"></iron-icon>
                  </paper-cell>
                  <paper-cell slot="header">
                    <span>Mobile</span>
                  </paper-cell>
                  <paper-header
                    selected$="[[equal(category, 'mobile_options')]]"
                    slot="content"
                    name="mobile_options"
                    on-click="clickNavItem"
                  >
                    <paper-cell icon>
                      <iron-icon icon="settings"></iron-icon>
                    </paper-cell>
                    <paper-cell>
                      <span>Mobile Options</span>
                    </paper-cell>
                  </paper-header>
                  <template is="dom-if" if="[[companyModules.mobile_assessment]]">
                    <paper-header
                      selected$="[[equal(category, 'mobile_assessments')]]"
                      slot="content"
                      name="mobile_assessments"
                      on-click="clickNavItem"
                    >
                      <paper-cell icon>
                        <iron-icon icon="hardware:smartphone"></iron-icon>
                      </paper-cell>
                      <paper-cell>
                        <span>Mobile Assessments</span>
                      </paper-cell>
                    </paper-header>
                  </template>
                </paper-header-content>
                <template is="dom-if" if="[[showWorkflowSection(companyModules.pole_application_portal, syncToModels, modelSpace)]]">
                  <paper-header-content tall>
                    <paper-cell icon slot="header">
                      <material-icon icon="fact_check"></material-icon>
                    </paper-cell>
                    <paper-cell slot="header">
                      <span>Pole Application Portal</span>
                    </paper-cell>
                    <paper-header
                      selected$="[[equal(category, 'portal_app_types')]]"
                      slot="content"
                      name="portal_app_types"
                      on-click="clickNavItem"
                    >
                      <paper-cell icon>
                        <material-icon icon="assignment"></material-icon>
                      </paper-cell>
                      <paper-cell>
                        <span>Application Types</span>
                      </paper-cell>
                    </paper-header>
                    <!-- <paper-header selected$="[[equal(category, 'portal_overview_attributes')]]" slot="content" name="portal_overview_attributes" on-click="clickNavItem">
                      <paper-cell icon>
                        <material-icon icon="list"></material-icon>
                      </paper-cell>
                      <paper-cell>
                        <span>Overview Attributes</span>
                      </paper-cell>
                    </paper-header> -->
                    <paper-header
                      selected$="[[equal(category, 'portal_user_options')]]"
                      slot="content"
                      name="portal_user_options"
                      on-click="clickNavItem"
                    >
                      <paper-cell icon>
                        <material-icon icon="manage_accounts"></material-icon>
                      </paper-cell>
                      <paper-cell>
                        <span>User Options</span>
                      </paper-cell>
                    </paper-header>
                    <paper-header
                      selected$="[[equal(category, 'portal_display_options')]]"
                      slot="content"
                      name="portal_display_options"
                      on-click="clickNavItem"
                    >
                      <paper-cell icon>
                        <material-icon icon="display_settings"></material-icon>
                      </paper-cell>
                      <paper-cell>
                        <span>Display Options</span>
                      </paper-cell>
                    </paper-header>
                  </paper-header-content>
                </template>
                <template is="dom-if" if="[[companyModules.hub]]">
                  <paper-header-content tall>
                    <paper-cell icon slot="header">
                      <material-icon icon="pending_actions"></material-icon>
                    </paper-cell>
                    <paper-cell slot="header">
                      <span>Hub And Application Management</span>
                    </paper-cell>
                    <paper-header
                      selected$="[[equal(category, 'hub_application_configurations')]]"
                      slot="content"
                      name="hub_application_configurations"
                      on-click="clickNavItem"
                    >
                      <paper-cell icon>
                        <material-icon icon="assignment"></material-icon>
                      </paper-cell>
                      <paper-cell>
                        <span>Application Configurations</span>
                      </paper-cell>
                    </paper-header>
                  </paper-header-content>
                </template>
                <template is="dom-if" if="[[equal(userGroup, 'katapult')]]">
                  <template is="dom-if" if="[[equal(userGroup, modelSpace)]]">
                    <paper-header selected$="[[equal(category, 'time_categories')]]" tall name="time_categories" on-click="clickNavItem">
                      <paper-cell icon>
                        <iron-icon icon="assignment"></iron-icon>
                      </paper-cell>
                      <paper-cell>
                        <span>Time Categories</span>
                      </paper-cell>
                    </paper-header>
                  </template>
                </template>
                <template is="dom-if" if="[[equal(userGroup, modelSpace)]]">
                  <paper-header selected$="[[equal(category, 'reference_layers')]]" tall name="reference_layers" on-click="clickNavItem">
                    <paper-cell icon>
                      <iron-icon icon="maps:place"></iron-icon>
                    </paper-cell>
                    <paper-cell>
                      <span>Reference Layers</span>
                    </paper-cell>
                  </paper-header>
                </template>
                <template is="dom-if" if="[[equal(userGroup, modelSpace)]]">
                  <paper-header selected$="[[equal(category, 'api_layers')]]" tall name="api_layers" on-click="clickNavItem">
                    <paper-cell icon>
                      <iron-icon icon="maps:layers"></iron-icon>
                    </paper-cell>
                    <paper-cell>
                      <span>API Layers</span>
                    </paper-cell>
                  </paper-header>
                </template>
                <paper-header selected$="[[equal(category, 'files')]]" tall name="files" on-click="clickNavItem">
                  <paper-cell icon>
                    <iron-icon icon="editor:insert-drive-file"></iron-icon>
                  </paper-cell>
                  <paper-cell>
                    <span>Files</span>
                  </paper-cell>
                </paper-header>
                <paper-header selected$="[[equal(category, 'quality_control')]]" tall name="quality_control" on-click="clickNavItem">
                  <paper-cell icon>
                    <iron-icon icon="icons:assignment"></iron-icon>
                  </paper-cell>
                  <paper-cell>
                    <span>Quality Control</span>
                  </paper-cell>
                </paper-header>
                <paper-header selected$="[[equal(category, 'model_options')]]" tall name="model_options" on-click="clickNavItem">
                  <paper-cell icon>
                    <iron-icon icon="settings"></iron-icon>
                  </paper-cell>
                  <paper-cell>
                    <span>Model Options</span>
                  </paper-cell>
                </paper-header>
                <template is="dom-if" if="[[enabledFeatures.cross_server_model_sharing]]" restamp>
                  <katapult-firebase-worker
                    path="[[modelSpaceDetails.path]]/sharing_links/model_sharing"
                    data="{{modelSharingLinks}}"
                  ></katapult-firebase-worker>
                  <paper-header
                    selected$="[[equal(category, 'cross_server_model_space_sharing')]]"
                    tall
                    name="cross_server_model_space_sharing"
                    on-click="clickNavItem"
                  >
                    <paper-cell icon>
                      <material-icon icon="cloud_sync"></material-icon>
                    </paper-cell>
                    <paper-cell>
                      <span>Model Sharing</span>
                    </paper-cell>
                    <template is="dom-if" if="[[_sharedModelsOutOfDate(modelSharingLinks)]]">
                      <paper-cell
                        icon
                        title="Shared copies of this model have not been updated.  Click 'Update Now' in the Model Sharing editor to update."
                      >
                        <material-icon style="color: var(--paper-red-500);" icon="warning"></material-icon>
                      </paper-cell>
                    </template>
                  </paper-header>
                </template>
                <div style="flex-grow: 1;"></div>
              </div>
              <paper-row
                style="background: var(--paper-grey-50); border-top: 1px solid var(--paper-grey-300);"
                on-click="toggleNavPanelCollapsed"
                pointer
              >
                <div style="flex-grow: 1"></div>
                <paper-cell icon style="margin: 4px;">
                  <iron-icon id="navPanelCollapseButton" icon="chevron-left"></iron-icon>
                </paper-cell>
              </paper-row>
            </div>
            <div id="workspaceContainer">
              <katapult-model-space-creation-wizard
                id="wizard"
                config="[[config]]"
                creating-model-space="{{creatingModelSpace}}"
                enabled-features="[[enabledFeatures]]"
                model-space="[[modelSpace]]"
                model-space-details="[[modelSpaceDetails]]"
                model-space-chooser-options="{{modelSpaceChooserOptions}}"
                user-group="[[userGroup]]"
                user-company-name="{{userCompanyName}}"
                workspace="[[$.workspace]]"
                user-modules="[[userModules]]"
                on-set-model-space="setModelSpaceEvent"
              >
              </katapult-model-space-creation-wizard>
              <katapult-model-editor-workspace
                id="workspace"
                category="{{category}}"
                config="[[config]]"
                model-space="{{modelSpace}}"
                model-space-details="{{modelSpaceDetails}}"
                model-space-chooser-options="{{modelSpaceChooserOptions}}"
                selected-item="{{selectedItem}}"
                signed-in="[[signedIn]]"
                show-import-pla="{{showImportPla}}"
                show-catalog="{{showCatalog}}"
                user-company-name="{{userCompanyName}}"
                user-group="{{userGroup}}"
                on-delete-model-space="promptDeleteModelSpace"
                company-modules="[[companyModules]]"
              >
              </katapult-model-editor-workspace>
              <shared-model-space-details
                id="sharedModelSpaceDetails"
                model-space-details="[[modelSpaceDetails]]"
                user-group="[[userGroup]]"
              >
              </shared-model-space-details>
            </div>
          </div>
        </div>
      </katapult-auth>
    `;
  }

  static get properties() {
    return {
      category: {
        type: Boolean,
        observer: 'categoryChanged'
      },
      enabledFeatures: {
        type: Object,
        value: () => ({})
      },
      modelSpace: {
        type: String
      },
      selectedItem: String,
      showCatalog: {
        type: Boolean,
        value: false
      },
      showNavPanel: {
        type: Boolean,
        value: true
      },
      companyModels: {
        type: Array,
        value: () => []
      },
      signedIn: {
        type: Boolean,
        value: false
      },
      modelsLockedForTransfer: {
        type: Boolean,
        value: false
      }
    };
  }

  static get observers() {
    return [
      'updateShowNavPanel(showCatalog, modelSpaceDetails, creatingModelSpace, showImportPla)',
      'initializeModelSpace(userGroup)',
      'updateTransferLockingListener(userGroup)',
      'updateDdsExportConfigured(ddsExportUtilityName)'
    ];
  }

  connectedCallback() {
    super.connectedCallback();

    this.beforeUnloadHandler = async (e) => {
      if (this.$.workspace.pendingChanges()) {
        e.preventDefault();
        e.returnValue = '';
      }
    };

    window.addEventListener('beforeunload', this.beforeUnloadHandler);

    this.crossServerModelSharingFlagListener = addFlagListener('cross_server_model_sharing', (enabled) => {
      this.set('enabledFeatures.cross_server_model_sharing', enabled);
    });

    this.configurableExportsFlagListener = addFlagListener('configurable_exports', (enabled) => {
      this.set('enabledFeatures.configurable_exports', enabled);
    });

    this.webAutomationsFlagListener = addFlagListener('web_automations', (enabled) => {
      this.set('enabledFeatures.web_automations', enabled);
    });

    this.constructionSpecsFlagListener = addFlagListener('construction_specs', (enabled) => {
      this.set('enabledFeatures.construction_specs', enabled);
    });

    this.integratedPoleLoadingImporterFlagListener = addFlagListener('integrated_pole_loading_importer', (enabled) => {
      this.set('enabledFeatures.integrated_pole_loading_importer', enabled);
    });

    this.compatibleUnitEditorFlagListener = addFlagListener('compatible_unit_editor', (enabled) => {
      this.set('enabledFeatures.compatible_unit_editor', enabled);
    });

    this.sharedWorkflowConfigsListener = addFlagListener('shared_workflow_configs', (enabled) => {
      this.set('enabledFeatures.shared_workflow_configs', enabled);
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    window.removeEventListener('beforeunload', this.beforeUnloadHandler);

    removeFlagListener('cross_server_model_sharing', this.crossServerModelSharingFlagListener);
    removeFlagListener('configurable_exports', this.configurableExportsFlagListener);
    removeFlagListener('web_automations', this.webAutomationsFlagListener);
    removeFlagListener('construction_specs', this.constructionSpecsFlagListener);
    removeFlagListener('integrated_pole_loading_importer', this.integratedPoleLoadingImporterFlagListener);
    removeFlagListener('compatible_unit_editor', this.compatibleUnitEditorFlagListener);
    removeFlagListener('shared_workflow_configs', this.sharedWorkflowConfigsListener);
    this.disconnectTransferLockingListener?.();
  }

  ready() {
    super.ready();
    this.appConfiguration = new AppConfiguration(this);

    let anim = new AnimationManager(this);

    anim.register(this.$.sideNavPanel, {
      observer: 'showNavPanel, navPanelCollapsed',
      rules: [
        {
          if: true,
          style: {
            width: () => (this.navPanelCollapsed ? '56px' : '340px'),
            marginLeft: '0px'
          }
        },
        {
          if: (showNavPanel) => !showNavPanel,
          style: {
            marginLeft: () => (this.navPanelCollapsed ? '-56px' : '-340px')
          }
        }
      ]
    });

    anim.register(this.$.navPanelCollapseButton, {
      observer: 'navPanelCollapsed',
      rules: [
        {
          if: true,
          style: {
            transform: 'none'
          }
        },
        {
          if: (navPanelCollapsed) => navPanelCollapsed,
          style: {
            transform: 'rotate(-180deg)'
          }
        }
      ]
    });

    anim.register(this.$.workspace, {
      observer: 'modelSpaceDetails, creatingModelSpace',
      rules: [
        {
          if: true,
          style: {
            $invisible: true,
            transform: 'translateX(128px)'
          }
        },
        {
          if: (modelSpaceDetails, creatingModelSpace) => modelSpaceDetails && !modelSpaceDetails.shared && !creatingModelSpace,
          style: {
            $invisible: false,
            transform: 'none'
          }
        }
      ]
    });

    anim.register(this.$.wizard, {
      observer: 'modelSpace, creatingModelSpace',
      rules: [
        {
          if: true,
          style: {
            $invisible: true,
            transform: 'translateX(128px)'
          }
        },
        {
          if: (modelSpace, creatingModelSpace) => !modelSpace || creatingModelSpace,
          style: {
            $invisible: false,
            transform: 'none'
          }
        }
      ]
    });

    anim.register(this.$.sharedModelSpaceDetails, {
      observer: 'modelSpaceDetails, creatingModelSpace',
      rules: [
        {
          if: true,
          style: {
            $invisible: true,
            transform: 'translateX(128px)'
          }
        },
        {
          if: (modelSpaceDetails, creatingModelSpace) => modelSpaceDetails?.shared && !creatingModelSpace,
          style: {
            $invisible: false,
            transform: 'none'
          }
        }
      ]
    });

    anim.register(this.$.modelSpaceChooser, {
      observer: 'modelSpace, creatingModelSpace',
      rules: [
        {
          if: true,
          style: { $invisible: true, transform: 'translateX(-24px)' }
        },
        {
          if: (modelSpace, creatingModelSpace) => modelSpace && !creatingModelSpace,
          style: { $invisible: false, transform: 'none' }
        }
      ]
    });

    anim.register(this.$.modelTagsEditorButton, {
      observer: 'modelSpaceDetails, creatingModelSpace, companyModules',
      rules: [
        {
          if: true,
          style: { $invisible: true, transform: 'translateX(24px)' }
        },
        {
          if: (modelSpaceDetails, creatingModelSpace, companyModules) =>
            modelSpaceDetails && !modelSpaceDetails.shared && !creatingModelSpace,
          style: { $invisible: false, transform: 'none' }
        }
      ]
    });

    anim.register(this.$.showImportPlaButton, {
      observer: 'modelSpaceDetails, creatingModelSpace, companyModules',
      rules: [
        {
          if: true,
          style: { $invisible: true, transform: 'translateX(24px)' }
        },
        {
          if: (modelSpaceDetails, creatingModelSpace, companyModules) =>
            modelSpaceDetails &&
            !modelSpaceDetails.shared &&
            !creatingModelSpace &&
            (companyModules?.pole_loading_exports || companyModules?.integrated_pole_loading),
          style: { $invisible: false, transform: 'none' }
        }
      ]
    });

    anim.register(this.$.importFromCatalogButton, {
      observer: 'modelSpaceDetails, creatingModelSpace',
      rules: [
        {
          if: true,
          style: { $invisible: true, transform: 'translateX(24px)' }
        },
        {
          if: (modelSpaceDetails, creatingModelSpace) => modelSpaceDetails && !modelSpaceDetails.shared && !creatingModelSpace,
          style: { $invisible: false, transform: 'none' }
        }
      ]
    });

    // Default category if not set.
    if (this.category == null) this.category = 'attributes';
    if (!this.$.workspace.modelSpace && this.modelSpace) this.$.workspace.setModelSpace(this.modelSpace);
    if (!this.$.workspace.category && this.category) this.$.workspace.setCategory(this.category);
    if (!this.$.workspace.selectedItem && this.selectedItem) {
      if (this.$.workspace.categoryDetails?.showEditor) {
        this.selectedItem = null;
      } else {
        this.$.workspace.setSelectedItem(this.selectedItem, true);
        this.$.workspace.editSelectedItem();
      }
    }
  }

  updateTransferLockingListener(userGroup) {
    this.disconnectTransferLockingListener?.();
    if (!userGroup) return;

    this.disconnectTransferLockingListener = listenToTransferLocking(userGroup, async (transferLocking) => {
      this.modelsLockedForTransfer = transferLocking?.lock_models;
      if (this.modelsLockedForTransfer) {
        let userGroupModelsRef = globalThis.FirebaseWorker.ref(`photoheight/company_space/${userGroup}/model_options`);
        await userGroupModelsRef.once('value').then((s) => {
          this.set(
            'companyModels',
            (s.val() || []).map((x) => x.value)
          );
        });
      }
    });
  }

  clickNavItem(e) {
    let name = e.currentTarget.getAttribute('name');
    if (name) {
      let [category, filter] = name.split('.');
      let temp = { category };
      if (category) this.$.workspace.setView(temp);
    }
  }

  showTransferInProgressDialog(modelSpace, modelsLockedForTransfer, companyModels) {
    if (!modelSpace || !modelsLockedForTransfer) return;
    if (companyModels.includes(modelSpace)) setTimeout(() => this.$.transferInProgressDialog.open(), 100);
  }

  showNoAccessDialog(userGroup, adminsOnly, isAdmin, userPermissions, userPermissionsLoading) {
    // Don't try to determine permissions until user data and permissions have loaded
    if (!userGroup || userPermissionsLoading) return false;
    // Show the return to other models button if the user is blocked because only admins can edit the particular
    // model, they are not an admin, and they have general read access (meaning they could have access to another model)
    this.showModelReturnButton = adminsOnly && !isAdmin && userPermissions?.model_editor_read_access;
    // Show the read only banner if the user does not have write access but had read access
    this.showReadOnlyBanner = !userPermissions?.model_editor_write_access && userPermissions?.model_editor_read_access;
    // Show the no access dialog if the user is not an admin and the
    // model requires admins to edit, or if they user does not have read access
    return (adminsOnly && !isAdmin) || !userPermissions?.model_editor_read_access;
  }

  hideReadOnlyBanner() {
    this.shadowRoot.querySelector('#readOnlyBanner').style.display = 'none';
  }

  returnToModels() {
    this.$.transferInProgressDialog.close();
    this.$.onlyAdmins.close();
    this.setModelSpace(null);
    this.shadowRoot.querySelector('#wizard').goToWelcome();
  }

  async confirmDeleteModelSpace() {
    this.deletingModelSpace = true;

    let success = false;
    let error = null;

    let update = {
      [`photoheight/companies/${this.modelSpaceDetails.$key}`]: null,
      [`photoheight/company_space/${this.modelSpaceDetails.$key}`]: null
    };

    await FirebaseWorker.ref()
      .update(update)
      .catch((err) => (error = err));

    if (!error) {
      await FirebaseWorker.ref(`photoheight/company_space/${this.userGroup}/model_options`).transaction(
        (modelOptions) => {
          if (modelOptions == null) modelOptions = [];
          if (Array.isArray(modelOptions)) {
            let index = modelOptions.findIndex((x) => x.label == this.modelSpaceDetails.label);
            if (index != -1) modelOptions.splice(index, 1);
          } else {
            // Abort transaction.
            return undefined;
          }
          return modelOptions;
        },
        (err, committed) => {
          if (err) error = err;
          success = committed;
        }
      );
    }

    if (success) {
      this.$.deleteModelSpaceDialog.close();
    } else {
      if (error) throw error;
      else throw 'Model could not be deleted';
    }

    this.deletingModelSpace = false;
  }

  createNewModelSpace() {
    this.$.wizard.beginCreateModelSpace();
  }

  equal(a, b) {
    return a == b;
  }

  beginImportPla() {
    this.$.workspace.setShowImportPla(true);
  }

  importFromCatalog() {
    this.$.workspace.setShowCatalog(true);
  }

  initializeModelSpace() {
    // if (!this.modelSpace && this.userGroup) this.$.workspace.setModelSpace(this.userGroup);
  }

  modelSpaceInputChanged(e) {
    e.currentTarget.value = this.modelSpaceDetails;
    this.setModelSpace(e.detail.value.$key);
  }

  promptDeleteModelSpace() {
    this.$.deleteModelSpaceDialog.open();
  }

  toggleNavPanelCollapsed() {
    this.navPanelCollapsed = !this.navPanelCollapsed;
  }

  setModelSpaceEvent(e) {
    this.setModelSpace(e.detail);
  }

  setModelSpace(modelSpace) {
    this.$.workspace.setModelSpace(modelSpace);
  }

  _sharedModelsOutOfDate(sharingLinks) {
    return Object.values(sharingLinks ?? {}).some((x) => !x.pending && !x.metadata?.up_to_date);
  }

  updateShowNavPanel(category) {
    this.showNavPanel =
      !this.showCatalog && this.modelSpaceDetails && !this.modelSpaceDetails.shared && !this.creatingModelSpace && !this.showImportPla;
  }

  onSignIn() {
    this.$.toolbar.featureCheck();
  }

  updateDdsExportConfigured(ddsExportUtilityName) {
    const enabled = ddsExportUtilityName != null;
    this.set('enabledFeatures.dds_export', enabled);
  }

  async categoryChanged(category) {
    // If category has been set to a valid value, check if the nav panel item is in a collapsed region and, if so, open it.
    if (category) {
      // Make sure the nav panel exists.
      const navPanelItem = await new Promise((resolve) => {
        const navPanelItem = this.shadowRoot?.querySelector(`[name="${category}"]`);
        if (navPanelItem) return resolve(navPanelItem);

        const observer = new MutationObserver(() => {
          const navPanelItem = this.shadowRoot?.querySelector(`[name="${category}"]`);
          if (navPanelItem) {
            observer.disconnect();
            resolve(navPanelItem);
          }
        });

        observer.observe(this.shadowRoot, { childList: true, subtree: true });
      });

      // When it does, open the parent if it's closed
      if (navPanelItem) {
        const parent = navPanelItem.closest('paper-header-content');
        if (parent && !parent.opened) parent.open();
      }
    }
  }

  showWorkflowSection(poleApplicationPortal) {
    const currentModelSpaceInSynced = (this.syncToModels ?? []).includes(this.modelSpace);
    return poleApplicationPortal && !currentModelSpaceInSynced;
  }

  openModelTagsEditor() {
    this.$.modelTagsEditor.open();
  }
}

customElements.define('katapult-model-editor-page', KatapultModelEditorPage);
